import { AssetLicenseResponse } from 'app/types/isomorphic';
import { AxiosInstance } from 'axios';
import apiUrl from '../apiUrl';

export class LicenseService {
  #httpClient: AxiosInstance;
  baseUrl: string;

  constructor(httpClient: AxiosInstance) {
    this.#httpClient = httpClient;
    this.baseUrl = `${apiUrl}/license`;
  }

  getActiveLicense = async (assetId: string): Promise<AssetLicenseResponse> => {
    try {
      const url = `${this.baseUrl}/active-license/${assetId}`;
      const response = await this.#httpClient.get<AssetLicenseResponse>(url);
      return response.data;
    } catch (e) {
      return {};
    }
  };
}

export default LicenseService;
